import * as Typings from '../typings'
import { BRAND_LIST, DistanceUnit } from 'typings'

const UnitedStatesLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.NORTH_AMERICA,
  CODE: 'us',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'United States',
  SHORT_NAME: 'US',

  DISPLAY_NAME: 'United States (English)',
  DISPLAY_COUNTRY: 'United States',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 37.0902,
    INITIAL_LONGITUDE: -95.7129,
    INITIAL_ZOOM: 3,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/us/en/',

  MAP_URL: 'https://www.uniqlo.com/us/en/find-stores/',
  MAP_MOBILE_URL: 'https://map.uniqlo.com/us/en/',

  TERMS_OF_USE_URL:
    'https://faq-us.uniqlo.com/articles/en_US/FAQ/Terms-Conditions/?l=en_US&c=category_uq_us%3Aerms_Conditions&fs=Search&pn=1',
  PRIVACY_POLICY_URL:
    'https://faq-us.uniqlo.com/pkb_Home_UQ_US?l=en_US&c=category_uq_us%3AUQ_C6_3',

  CONTACT_US_URL: 'https://faq-us.uniqlo.com/',

  POSTCODE_FORMAT: '^(?!^.{10})([0-9]{5}|(^[0-9]{9}))$',
  DISTANCE_UNIT: DistanceUnit.MILE,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
    [BRAND_LIST.GU]: '',
  },

  CMS_ENABLED: {
    [BRAND_LIST.UQ]: true,
    [BRAND_LIST.GU]: true,
  },

  AM_FORMAT: ' AM',
  PM_FORMAT: ' PM',

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
    [BRAND_LIST.GU]: true,
  },
}

export default UnitedStatesLocale
